var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wine-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---App-views",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "All-products",
    transform: "translate(-48, -661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-4",
    transform: "translate(24, 637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wine-icon",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "wine",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7797867,3.22 C10.8374133,2.71484 11.26492,2.33333333 11.7733467,2.33333333 L20.2266667,2.33333333 C20.7344,2.33333333 21.1616,2.7138 21.22,3.21813333 L22.0333333,10.2314667 C22.0350667,10.2460933 22.0364,10.2607467 22.0374667,10.2754133 C22.0508,10.4613467 22.0666667,10.69364 22.0666667,10.9333333 C22.0666667,13.9449333 19.8758667,16.4417333 17,16.9181333 L17,27.6666667 L20.2266667,27.6666667 C20.7789333,27.6666667 21.2266667,28.1144 21.2266667,28.6666667 C21.2266667,29.2189333 20.7789333,29.6666667 20.2266667,29.6666667 L11.7733467,29.6666667 C11.2210667,29.6666667 10.7733467,29.2189333 10.7733467,28.6666667 C10.7733467,28.1144 11.2210667,27.6666667 11.7733467,27.6666667 L15,27.6666667 L15,16.9181333 C12.1241067,16.4417333 9.93334667,13.9449333 9.93334667,10.9333333 C9.93334667,10.6955333 9.94877333,10.4532933 9.98129333,10.2201333 L10.7797867,3.22 Z M12.66576,4.33333333 L12.2201333,8.24 L19.7890667,8.24 L19.336,4.33333333 L12.66576,4.33333333 Z M20.0209333,10.24 L11.992,10.24 L11.9669067,10.46 C11.96584,10.4693733 11.96464,10.4787467 11.9632933,10.4880933 C11.94392,10.6237067 11.9333467,10.7762 11.9333467,10.9333333 C11.9333467,13.1810533 13.7522667,15 16,15 C18.2477333,15 20.0666667,13.1810533 20.0666667,10.9333333 C20.0666667,10.7792933 20.0568,10.6184133 20.0441333,10.4398 L20.0209333,10.24 Z",
    id: "Shape",
    fill: "#00414B",
    mask: "url(#mask-4)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineIcon);
export default __webpack_public_path__ + "static/media/wine-icon.86fab32573d12fc34f2a5e9b3c380348.svg";
export { ForwardRef as ReactComponent };